import { SUBMIT_CONTACT_FORM, SUBMIT_CONTACT_FORM_SUCCESS, SUBMIT_CONTACT_FORM_FAILURE } from '../../constants/ActionTypes';

export const submitContactForm = (formData) => ({
  type: SUBMIT_CONTACT_FORM,
  payload: formData,
});

export const submitContactFormSuccess = (response) => ({
  type: SUBMIT_CONTACT_FORM_SUCCESS,
  payload: response,
});

export const submitContactFormFailure = (error) => ({
  type: SUBMIT_CONTACT_FORM_FAILURE,
  payload: error,
});